<template>
  <div>
    <q-dialog
      :visible.sync="dialogVisible"
      title="首批量"
      width="300px"
      :innerHeight="60"
      @cancel="updateVal"
      @confirm="confirm"
      @close="updateVal"
    >
      <el-form :model="form" size="small" :rules="rules" ref="ruleForm">
        <el-form-item label="调整数量" prop="firstBatch">
          <el-input v-model="form.firstBatch" :placeholder="placeholderVal" />
        </el-form-item>
      </el-form>
    </q-dialog>
  </div>
</template>

<script>
import { isIntZero } from '@/utils/validate.js'
import mixin from '@/views/preSalePlan/utils/mixin.js'
export default {
  mixins: [mixin],
  model: {
    prop: 'visible',
    event: 'input'
  },
  props: ['visible', 'data'],
  data() {
    const validator_IntZero = (rule, value, callback) => {
      if(isIntZero(value)) {
        callback()
      }else{
        callback(new Error('必须为正整数'))
      }
    }
    return {
      dialogVisible: false,
      // 业务代码
      form: {},
      rules: {
        firstBatch: [
          { required: true, message: '调整数量不能为空', trigger: 'blur'},
          { validator: validator_IntZero, trigger: 'change' }
        ]
      },
      placeholderVal: ''
    }
  },
  mounted() {
    this.placeholderVal = this.data.firstBatch;
    this.dialogVisible = this.visible;
  },
  methods: {
    updateVal() {
      this.dialogVisible = false;
      setTimeout(_=>{
        this.$emit('input', false)
      },200)
    },
    confirm() {
      this.$refs['ruleForm'].validate(valid=>{
        if(valid) {
          let data = {
            data: {
              productCode: this.data.productCode,
              planTime: this.planTime,
              storeId: this.storeId,
              firstBatch: this.form.firstBatch
            }
          }
          this.$q.preSalePlan.firstBatchEdit(data)
          .then(res=>{
            res.code == 200 && this.$message.success('修改成功')
          })
          .finally(_=>{
            this.updateVal();
            this.$parent.init();
          })
        }
      })
    }
  }
}
</script>

<style>

</style>